import angular from 'angular';

let inject = ['$scope', '$uibModalInstance', 'SessionService','$timeout', '$state', 'OrdersService', 'shCtrl', 'orderId'];

class ModalDriversOrderRegisterController {

    constructor($scope, $uibModalInstance, SessionService,$timeout, $state, OrdersService, shCtrl, orderId ) {
        this.OrdersService = OrdersService;
        this.directions = [];
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$state = $state;
        this.SessionService = SessionService;
        this.newDriver = {};
        this.drivers = [];
        this.showError = null;
        this.showSuccess = null;
        this.showErrorAlone = null;
        this.shCtrl = shCtrl;
        this.orderId=orderId;

        console.log(this.orderId);
    }

    $onInit() {

        this.continueSaveDriver = false;
        this.savingDriver=false;

        this.getOrderDrivers();

        if(this.drivers.length == 10){
            this.showErrorAlone = "No es posible asignar más de 10 conductores para el mismo pedido";
        }
    }

    saveDriver() {
        if (this.driverForm.$valid) {
            this.savingDriver=true;
            this.showErrorAlone = '';


            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {}

            let flagDriver = true;
            let countDrivers = 0;

            angular.forEach(this.drivers, (value, key) => {
                countDrivers++;
                if(this.newDriver.cedula == value.conductor_documento){
                    flagDriver = false;
                    this.showErrorAlone += "Ya existe un conductor agendado con la cédula ingresada. ";
                    this.savingDriver =false;
                    this.continueSaveDriver = false;
                }

                if(angular.uppercase(this.newDriver.placa) == angular.uppercase(value.placa_vehiculo)){
                    flagDriver = false;
                    this.showErrorAlone += "Ya existe un conductor agendado con la placa de vehículo ingresada. ";
                    this.savingDriver =false;
                    this.continueSaveDriver = false;
                }
            });

            if(this.drivers.length  >= 10){
                flagDriver = false;
                this.showErrorAlone = "No es posible asignar más de 10 conductores para el mismo pedido";
                this.savingDriver =false;
                this.continueSaveDriver = false;
            }


            if (flagDriver) {

                let data = {
                    driver: this.newDriver,
                    orderId: this.orderId
                };

                this.OrdersService.saveOrderDriver(data).then((response) => {

                    if (response.error) {
                        this.showErrorAlone = response.message;
                        this.savingDriver =false;
                        this.continueSaveDriver = false;
                    } else {
                        this.showSuccess = response.message;
                        this.continueSaveDriver=true;
                    }

                });

            }

        } else {
            this.driverForm.cedula.$setDirty();
            this.driverForm.nombre.$setDirty();
            this.driverForm.placa.$setDirty();
            this.driverForm.telefono.$setDirty();
        }
    }

    redirectAllDirections(){
        this.$state.go('home.address');
        this.$uibModalInstance.dismiss('cancel');
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    resetModal(){
        this.showSuccess = null;
        this.savingDriver =false;
        this.continueSaveDriver = false;
        this.newDriver = {};
        this.getOrderDrivers();

        if(this.drivers.length == 10){
            this.showErrorAlone = "No es posible asignar más de 10 conductores para el mismo pedido";
        }
    }


    getOrderDrivers(){
        this.OrdersService.getPedidoConductores({orderId: this.orderId}).then((response) => {

            if (response.error) {

            } else {
                this.drivers = response.data;
                console.log(this.drivers)
            }

        });
    }

}

ModalDriversOrderRegisterController.$inject = inject;

export default ModalDriversOrderRegisterController;



/** WEBPACK FOOTER **
 ** ./www/components/orders/modal-drivers-register/modal-drivers-order-register.controller.js
 **/